import { FC, memo, useCallback, useContext } from 'react'

import { SliderContainer } from './styles'
import { useTranslation } from '../../../hooks/locale'
import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { ScreenContext } from 'react-components'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import ReviewsCard from '../../common/reviews-card'
import { CtaButtonText, CtaContainer, Section, StyledGhostButton, Title, TitleContainer } from '../common/styles'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { EmblaCarousel } from '../../common/embla-carousel'

interface Props {
    topRatedObjectsSection: ListingSectionTransport
    breadcrumbList?: BreadcrumbListTransport
    url: string
    defaultHeading: string
}

const ReviewsSection: FC<Props> = ({ topRatedObjectsSection, breadcrumbList, url, defaultHeading }) => {
    const { objects: reviewObjects, cta } = topRatedObjectsSection
    const { t } = useTranslation()
    const { isTablet, isDesktop } = useContext(ScreenContext)

    const heading = topRatedObjectsSection.heading || defaultHeading

    const _handleViewAllAccommodationsClick = useCallback(() => {
        document.location.href = cta?.url || url
    }, [url, cta?.url])

    const visibleSlides = isDesktop ? 3 : isTablet ? 1.75 : 1.1

    return (
        <Section id="reviews">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <SliderContainer>
                <EmblaCarousel
                    slides={reviewObjects.map((reviewObject, index) => (
                        <ReviewsCard
                            key={reviewObject.id}
                            listing={reviewObject}
                            position={index}
                            breadcrumbList={breadcrumbList}
                            pageName={pageTypeEventCategories.HOME}
                            sectionName={cardEventCategories.sections.REVIEW}
                        />
                    ))}
                    visibleSlides={visibleSlides}
                    slidesToScroll={1}
                    showNav
                    navVariant="top-right"
                    navPosition={{
                        desktopTop: '-3.5rem',
                        desktopRight: '0rem',
                        wideTop: '-3.5rem',
                        wideRight: '0rem',
                    }}
                />
            </SliderContainer>
            {cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleViewAllAccommodationsClick} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Section>
    )
}

export default memo(ReviewsSection)
